<template>
  <main>
    <ObTabs
      :tabs="tabs"
      :ellipsis="false"
      :shrink="true"
      :border="true"
      :titleStyle="{
        fontSize: '28px',
        padding: '0 18px 8px'
      }"
      :lazyRender="false"
      line-height="2"
      color="var(--color-brandSecondary-community)"
      background="#FFF"
      title-active-color="var(--color-text-primary)"
      title-inactive-color="var(--color-text-description)"
    >
      <template #explore>
        <Explore />
      </template>
      <template #myFollowing>
        <MyFollowing />
      </template>
      <template #myCircles>
        <MyCircles />
      </template>
      <template #[localName]>
        <LocalCountry />
      </template>
    </ObTabs>
    <RankList />
  </main>
</template>
<script setup>
import RankList from './rankList'
import Explore from './explore'
import MyFollowing from './myFollowing'
import MyCircles from './myCircles'
import LocalCountry from './localCountry'

import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'

const userStore = useUserStore()  // 用户仓库
const { uid } = storeToRefs(userStore)   // 用户id
const { proxy } = getCurrentInstance()


const localName = ref('')

const tabs = ref([{
  name: 'explore',
  title: proxy.$t('explore')
}])


async function getFollowingList () {
  // 获取关注列表
  const { code, data, msg } = await proxy.$http.getFollowingList({ uid: uid.value })
  if (code === 200) {
    const { total } = data || {}
    if (!total) return
    tabs.value.push({
      name: 'myFollowing',
      title: proxy.$t('myFollowing')
    })
  }
}

async function getMyCircleList () {
  const { code, data, msg } = await proxy.$http.getMyCircleList({
    page: 1,
  })
  if (code === 200 && data) {
    const { total } = data || {}
    if (!total) return
    tabs.value.push({
      name: 'myCircles',
      title: proxy.$t('myCircles')
    })
  }
}

async function getLocalCircle () {
  const { code, data, msg } = await proxy.$http.getLocalCircle({
    page: 1,
    limit: 1,
    sortType: 2
  })
  if ((code === 200) && data) {
    const { total, rows } = data || {}
    if (!total) return
    localName.value = rows[0].circleInfo.name
    const tab = {
      name: localName.value,
      title: localName.value
    }
    tabs.value.push(tab)
  }
}

onBeforeMount(async () => {
  const { VITE_COUNTRY } = import.meta.env
  if (uid.value) {
    await getFollowingList()
    await getMyCircleList()
  }
  if (VITE_COUNTRY === 'PARIS') {
    await getLocalCircle()
  }
})

</script>
<style lang="postcss" scoped>
main {
  display: flex;
  flex-flow: row nowrap;
  align-items: flex-start;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  padding: 48px 0 !important;
  background-color: #FFF;
  :deep(.ob-tabs) {
    width: 792px;
    .van-tabs__nav {
      padding-left: 0;
      margin-left: -18px;
    }
    .van-hairline--top-bottom:after {
      --van-border-width: 2px;
      border-top: 0;
      border-color: var(--color-divider-primary);
    }
  }
}
</style>